import React from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { UserMessage } from '../../DesignSystem/LiliUserMessage/UserMessage';
import { useChangeNaicsHook } from './logic/useChangeNaicsHook';
import { ChangeNaicsForm } from './ChangeNaicsForm';
import LiliNotification, { LiliNotificationType } from '../../DesignSystem/LiliNotification/LiliNotification';
import { LiliToastDefaultConfig } from '../../DesignSystem/LiliToast/LiliToast';
import useStore from '../../store';

export interface ChangeNaicsProps {
    onNaicsUpdated: () => void;
}

const ChangeNaics = ({ onNaicsUpdated }: ChangeNaicsProps) => {
  const {
    errorMessage,
    isLoading,
    isValid,
    onSubmit,
    onIndustriesChanged,
    industryList,
  } = useChangeNaicsHook({ onNaicsUpdated });

  return (
    <UserMessage id='change-naics-modal' onClick={() => {}} shouldPersist>
      <ChangeNaicsForm
        industryList={industryList}
        onIndustriesChanged={onIndustriesChanged}
        errorMessage={errorMessage}
        isLoading={isLoading}
        onSubmit={onSubmit}
        isValid={isValid}
      />
    </UserMessage>
  );
};

export const RenderNaicsModal = () => {
  const { t } = useTranslation();
  const { resetUserMessageSlice } = useStore(state => state);

  return <ChangeNaics
    onNaicsUpdated={() => {
      resetUserMessageSlice();
      toast(
        <LiliNotification
          type={LiliNotificationType.SUCCESS}
          title={t('CHANGE_NAICS.SUCCESS_MODAL_TITLE')}
          text={t('CHANGE_NAICS.SUCCESS_MODAL_DESCRIPTION')}
          id='change-naics-success-notification'
        />,
        {
          ...LiliToastDefaultConfig,
          position: toast.POSITION.BOTTOM_CENTER,
          closeOnClick: false,
          autoClose: false,
        },
      );
    }}
  />;
};
